import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Bot, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSound } from "../../hooks/useSound";
import "../../assets/styles/ChatBot.css"; // تأكد من مسار ملف الـ CSS

export default function ChatbotButton() {
  const navigate = useNavigate();
  const clickSound = useSound("/sounds/click.mp3");
  const [isHovered, setIsHovered] = useState(false);
  const [wiggle, setWiggle] = useState(false);

  // حركة "لفت الانتباه" كل 5 ثواني
  useEffect(() => {
    const interval = setInterval(() => {
      setWiggle(true);
      setTimeout(() => setWiggle(false), 800); // إيقاف الحركة بعد جزء من الثانية
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // إعدادات الـ Wiggle Animation
  const wiggleVariants = {
    idle: { scale: 1, rotate: 0 },
    wiggle: {
      scale: [1, 1.1, 1],
      rotate: [0, -10, 10, -10, 0],
      transition: { duration: 0.5, ease: "easeInOut" },
    },
  };

  return (
    <div 
      className="chatbot-fab-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Tooltip الذكي */}
      <AnimatePresence>
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, x: -20, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -10, scale: 0.8 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            className="fab-tooltip shadow-lg"
          >
            <span className="fw-bold me-2">Ask Pulse AI</span>
            <Sparkles size={16} className="text-warning" />
          </motion.div>
        )}
      </AnimatePresence>

      {/* موجات النبض الخلفية (Pulse Rings) */}
      <div className="fab-rings">
        <div className="fab-ring ring-1"></div>
        <div className="fab-ring ring-2"></div>
      </div>

      {/* الزرار الأساسي */}
      <motion.button
        onClick={() => {
          if (clickSound) clickSound(); // حماية لو الصوت لسه محملش
          navigate("/chatbot");
        }}
        variants={wiggleVariants}
        animate={wiggle ? "wiggle" : "idle"}
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.9 }}
        className="fab-main-btn shadow-lg"
        aria-label="Open Pulse AI Chat"
      >
        <motion.div
          animate={{ y: [-2, 2, -2] }} // حركة تنفس مستمرة للأيقونة
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
        >
          <Bot size={32} />
        </motion.div>
      </motion.button>
    </div>
  );
}

// // src/components/ChatbotButton.jsx
// import React, { useEffect } from "react";
// import { motion, useAnimation } from "framer-motion";
// import { Bot } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useSound } from "../../hooks/useSound";
// export default function ChatbotButton() {
//   const navigate = useNavigate();
//   const controls = useAnimation();
//   const clickSound = useSound("/sounds/click.mp3");

//   //  حركة تلقائية كل 5 ثواني لجذب الانتباه
//   useEffect(() => {
//     const animatePulse = () => {
//       controls.start({
//         scale: [1, 1.15, 1],
//         rotate: [0, 10, -10, 0],
//         transition: { duration: 0.8, ease: "easeInOut" },
//       });
//     };

//     animatePulse(); // أول حركة بعد التحميل
//     const interval = setInterval(animatePulse, 5000);

//     return () => clearInterval(interval);
//   }, [controls]);

//   return (
//     <motion.button
//       onClick={() => {
//         clickSound();
//         navigate("/chatbot");
//       }}
//       className="position-fixed"
//       style={{
//         bottom: "25px",
//         left: "25px",
//         background: "linear-gradient(135deg,#007BFF,#00B4D8,#48CAE4)",
//         color: "white",
//         borderRadius: "50%",
//         width: "65px",
//         height: "65px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         boxShadow: "0 0 20px rgba(0,0,0,0.4)",
//         zIndex: 999,
//         border: "none",
//         cursor: "pointer",
//       }}
//       initial={{ scale: 1, opacity: 1 }}
//       animate={controls}
//       whileHover={{
//         scale: 1.2,
//         rotate: 8,
//         boxShadow: "0 0 35px rgba(0,191,255,0.8)",
//       }}
//       whileTap={{ scale: 0.9 }}
//     >
//       <Bot size={34} />
//     </motion.button>
//   );
// }
